import Config from "./components/ClientConfig";

const stripTrailingSlash = (s) => (s || "").replace(/\/$/, "");
const stripLeadingSlash = (s) => (s || "").replace(/^\//, "");

export const BASE_URL = stripTrailingSlash(Config.BASE_URL); // https://rapoarte.kalopsia.pro
export const BASE_API_URL = `${BASE_URL}/${stripLeadingSlash(Config.BASE_API_URL)}`;
// -> https://rapoarte.kalopsia.pro/api/1.0/

export const toMediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_URL}${p}`;
};

export function withImageSize(pathOrUrl, size) {
  if (!pathOrUrl) return "";
  const s = String(pathOrUrl);

  const suffix = (size || "").toLowerCase();
  if (!["s", "m", "l", "xl"].includes(suffix)) return s;

  // keep query string
  const [base, query] = s.split("?");
  const q = query ? `?${query}` : "";

  // if already sized, do nothing
  if (/_((s|m|l|xl))\.(png|jpg|jpeg|webp)$/i.test(base)) {
    return base + q;
  }

  // insert _{size} before extension
  return base.replace(/\.(png|jpg|jpeg|webp)$/i, `_${suffix}.$1`) + q;
};

async function request(pathOrUrl) {
  // allow passing full URL or relative endpoint path
  const url =
    pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")
      ? pathOrUrl
      : `${BASE_API_URL}${stripLeadingSlash(pathOrUrl)}`;

  const res = await fetch(url);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${res.statusText}${text ? ` :: ${text}` : ""}`);
  }
  return res.json();
}

export const api = {
  // use endpoint paths (relative) so config controls everything
  getProducts: (languageIref = "") =>
    request(`product/${languageIref ? `?language=${encodeURIComponent(languageIref)}` : ""}`),
  getLocations: () => request("location/"),
  getCategoriesWithSub: (languageIref = "") =>
    request(
      `productCategory/withSubCategories/${
        languageIref ? `?language=${encodeURIComponent(languageIref)}` : ""
      }`
    ),
  getLanguages: () => request("config_languages/"),
  getWebsiteIdentity: () => request("config_website_identity/"),
  getAllergens: (languageIref = "") =>
    request(
      `product/list_allergens/${languageIref ? `?language=${encodeURIComponent(languageIref)}` : ""}`
    ),
};
